$(document).on('click', '.deleteServiceBtn', function(e) {
        e.preventDefault();
        var serviceId = $(this).data('id');

        swal({
            title: 'Are you sure?',
            text: 'Delete this Carrier Service!',
            icon: 'warning',
            buttons: {
                cancel: {
                    text: 'Cancel',
                    value: null,
                    visible: true,
                    className: 'btn btn-default',
                    closeModal: true,
                },
                confirm: {
                    text: 'Delete',
                    value: true,
                    visible: true,
                    className: 'btn btn-danger',
                    closeModal: true
                }
            }
        }).then((result) => {
            if (result) {
                // User confirmed deletion
                $.ajax({
                    headers: { 'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content') },
                    method: 'get',
                    url: '{{ route("carrierService.delete") }}',
                    data: { serviceId: serviceId },
                    success: function(response) {

						if(response.status=='success'){
							swal('Deleted!', response.message, 'success');
						}else{
							swal('Error!', 'Service Not Found', 'error');
						}
						setTimeout(function () {
							location.reload();
						}, 200);
                    },
                    error: function(error) {
                        // Handle error
                        swal('Error!', 'An error occurred while deleting the Service.', 'error');
                    }
                });
            }
        });
    });
